<shabic-dialog #dialog>
  <div class="w-full max-w-[400px] mx-auto">
    <header class="text-center">
      <div class="flex items-center justify-center mb-4">
        <img src="/assets/return-box.svg" />
      </div>

      <shabic-headline variant="h3">
        {{ 'common.return-order' | translate }}
      </shabic-headline>
      <shabic-sub-headline>
        {{ 'common.return-order-description' | translate }}
      </shabic-sub-headline>
    </header>

    <form
      class="mt-4 grid gap-1"
      [formGroup]="formGroup"
      (ngSubmit)="confirm(dialog)"
    >
      <div class="grid gap-1">
        <ng-container *ngIf="isCancelReasons">
          <shabic-form-field
            class="blok border-2 border-grey-350 rounded-2xl p-[20px]"
            [class.border-primary]="
              reasonControl.value === ECancelOrderReason.WrongProduct
            "
          >
            <shabic-radio-control>
              <input
                type="radio"
                id="wrong-product"
                shabicInput
                formControlName="reason"
                class="peer"
                [value]="ECancelOrderReason.WrongProduct"
                name="reason"
              />

              <shabic-form-field-label forAttribute="wrong-product">
                <span class="normal-case font-medium text-sm">
                  {{
                    getReasonKey(ECancelOrderReason.WrongProduct) | translate
                  }}
                </span>
              </shabic-form-field-label>
            </shabic-radio-control>
          </shabic-form-field>

          <shabic-form-field
            class="blok border-2 border-grey-350 rounded-2xl p-[20px]"
            [class.border-primary]="
              reasonControl.value === ECancelOrderReason.NotEnoughFunds
            "
          >
            <shabic-radio-control>
              <input
                type="radio"
                id="not-enough-funds"
                shabicInput
                formControlName="reason"
                class="peer"
                [value]="ECancelOrderReason.NotEnoughFunds"
                name="reason"
              />

              <shabic-form-field-label forAttribute="not-enough-funds">
                <span class="normal-case font-medium text-sm">
                  {{
                    getReasonKey(ECancelOrderReason.NotEnoughFunds) | translate
                  }}
                </span>
              </shabic-form-field-label>
            </shabic-radio-control>
          </shabic-form-field>
        </ng-container>

        <ng-container *ngIf="isReturnReasons">
          <shabic-form-field
            class="blok border-2 border-grey-350 rounded-2xl p-[20px]"
            [class.border-primary]="
              reasonControl.value === EReturnOrderReason.DamagedGoods
            "
          >
            <shabic-radio-control>
              <input
                type="radio"
                id="damaged-goods"
                shabicInput
                formControlName="reason"
                class="peer"
                [value]="EReturnOrderReason.DamagedGoods"
                name="reason"
              />

              <shabic-form-field-label forAttribute="damaged-goods">
                <span class="normal-case font-medium text-sm">
                  {{
                    getReasonKey(EReturnOrderReason.DamagedGoods) | translate
                  }}
                </span>
              </shabic-form-field-label>
            </shabic-radio-control>
          </shabic-form-field>

          <shabic-form-field
            class="blok border-2 border-grey-350 rounded-2xl p-[20px]"
            [class.border-primary]="
              reasonControl.value ===
              EReturnOrderReason.NotMeetingRequiredSpecifications
            "
          >
            <shabic-radio-control>
              <input
                type="radio"
                id="not-meeting-required-specifications"
                shabicInput
                formControlName="reason"
                class="peer"
                [value]="EReturnOrderReason.NotMeetingRequiredSpecifications"
                name="reason"
              />

              <shabic-form-field-label
                forAttribute="not-meeting-required-specifications"
              >
                <span class="normal-case font-medium text-sm">
                  {{
                    getReasonKey(
                      EReturnOrderReason.NotMeetingRequiredSpecifications
                    ) | translate
                  }}
                </span>
              </shabic-form-field-label>
            </shabic-radio-control>
          </shabic-form-field>
        </ng-container>

        <shabic-form-field
          class="blok border-2 border-grey-350 rounded-2xl p-[20px]"
          [class.border-primary]="!reasonControl.value"
        >
          <shabic-radio-control>
            <input
              type="radio"
              id="other"
              shabicInput
              formControlName="reason"
              class="peer"
              [value]="null"
              name="reason"
            />

            <shabic-form-field-label forAttribute="other">
              <span class="normal-case font-medium text-sm">
                {{ 'common.other' | translate }}
              </span>
            </shabic-form-field-label>
          </shabic-radio-control>
        </shabic-form-field>

        <shabic-form-field *ngIf="!reasonControl.value" class="mt-4">
          <shabic-form-field-label forAttribute="reason">
            {{ 'common.description' | translate }}
          </shabic-form-field-label>

          <textarea
            shabicInput
            rows="6"
            id="reason"
            class="resize-none"
            formControlName="description"
          ></textarea>
        </shabic-form-field>

        <!-- Photo Upload Section -->
        <shabic-form-field class="mt-4">
          <shabic-form-field-label>
            {{ 'common.upload-photos' | translate }}
          </shabic-form-field-label>
          
          <div class="grid gap-3">
            <div class="border-2 border-dashed border-grey-350 rounded-2xl p-4 text-center">
                             <ng-template shabicIcon="picture" class="text-grey-500 mb-2"></ng-template>
              <p class="text-sm text-grey-600 mb-2">
                {{ 'common.drag-and-drop-photos' | translate }}
              </p>
              <button
                type="button"
                shabicButton="secondary"
                class="text-sm"
                (click)="fileInput.click()"
              >
                {{ 'button.select-photos' | translate }}
              </button>
              <input
                #fileInput
                type="file"
                multiple
                accept="image/*"
                class="hidden"
                (change)="onFileSelected($event)"
              />
            </div>
            
            <!-- Upload Progress -->
            <div *ngIf="isUploading" class="upload-progress bg-blue-50 border border-blue-200 rounded-lg p-3 text-center">
              <div class="flex items-center justify-center gap-2">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                <span class="text-sm text-blue-700">{{ 'common.uploading-images' | translate }}...</span>
              </div>
            </div>
            
            <!-- Selected Photos Preview -->
            <div *ngIf="selectedFiles.length > 0" class="grid grid-cols-2 gap-2">
              <div 
                *ngFor="let file of selectedFiles; let i = index" 
                class="relative border rounded-lg p-2"
              >
                <img 
                  [src]="getFilePreview(file)" 
                  class="w-full h-20 object-cover rounded"
                  alt="Preview"
                />
                <button
                  type="button"
                  class="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs"
                  (click)="removeFile(i)"
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        </shabic-form-field>

        <!-- Disclaimer Section -->
        <div class="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-2xl">
          <div class="flex items-start gap-2">
            <ng-template shabicIcon="alert" class="text-blue-500 mt-0.5"></ng-template>
            <div class="flex-1">
              <shabic-headline variant="h5" class="text-blue-700 mb-1">
                {{ 'common.return-disclaimer-title' | translate }}
              </shabic-headline>
              <shabic-sub-headline class="text-blue-600">
                {{ 'common.return-disclaimer-text' | translate }}
              </shabic-sub-headline>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button
          type="submit"
          shabicButton="primary"
          class="w-full desktop:w-auto mt-5.5 mb-6"
          [disabled]="isUploading"
        >
          {{ 'button.confirm' | translate }}
        </button>
      </div>
    </form>
  </div>
</shabic-dialog>
